import styled from 'styled-components';

export const StyledLabelRow = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const StyledCounter = styled.span<{
  counterExceeded?: boolean;
}>`
  margin: 10px 10px 2px 0;
  font-size: 12px;
  font-weight: 600;
  color: ${({ counterExceeded, theme }) =>
    counterExceeded ? theme.color.bittersweet : theme.color.baliHai};
`;
